export default __webpack_public_path__ + "static/media/commercial-IM-default.531da0a6.jpeg";